import styled from "styled-components";
import { Layout, Menu } from "antd";
const { Sider, Header: H } = Layout;

const StyledImageHeader = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  padding: 4px 8px;
  line-height: 1;

  img {
    height: 36px;
    width: auto;
  }
`;

const StyledHeader1 = styled.p`
  margin-top: 0;
  margin-bottom: 0em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 150;
  display: block;
  font-size: 3em;
`;


const StyledSearchForm = styled.div`
  margin: 0px 0px 24px 0px;
  padding: 10px 10px 20px 20px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
`;


const GeneralStyledContent = styled(Layout.Content)`
  background: white;
  margin: 5px 5px 5px 5px;
  padding: 20px 20px 10px 20px;
  min-height: ${window.innerHeight - 55}px;
`;


const StyledSider = styled(Sider)`
  padding: 0;
  max-width: 270;
  min-width: 270;
  width: 270;
`;


const StyledLogo = styled.img`
  margin-left: 22%;
  margin-top: 100px;
`;


const StyledHearder = styled(H)`
  background: #dc3545 !important;
  color: #ffffff !important;
  padding: 0 24px !important;
  height: 64px !important;
  line-height: 64px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;

  .header-divider {
    width: 1px;
    height: 24px;
    background: rgba(255, 255, 255, 0.2);
    margin: 0 32px;
  }

  /* ปุ่มเมนูกับปุ่มโปรไฟล์ใน Header.js เป็น <button> เพื่อให้ Tab ถึงและกด Enter / Space ได้ (WCAG 2.1.1)
     ล้างสไตล์ปุ่มของ browser ไว้ก่อนกฎของแต่ละ class กฎด้านล่างจึงยังให้ขนาด ตำแหน่ง และสีเท่ากับ span เดิม */
  .header-menu-trigger,
  .header-profile {
    padding: 0;
    border: 0;
    background: none;
    font: inherit;
    color: inherit;
    text-align: inherit;
    cursor: pointer;
  }
  /* วงโฟกัสตอนใช้คีย์บอร์ด: พื้น header แดง #dc3545 จึงใช้วงขาว (4.53:1) แบบปุ่มปิด drawer เมนูใน sis-theme.css
     :focus-visible ไม่ขึ้นตอนคลิกเมาส์ คนที่ใช้เมาส์จึงเห็นหน้าตาเดิม */
  .header-menu-trigger:focus-visible,
  .header-profile:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

  .header-menu-trigger {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 6px 16px;
    border-radius: 9999px;
    cursor: pointer;
    transition: color 0.2s, background-color 0.2s;
  }
  .header-menu-trigger:hover {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.1);
  }

  .header-profile {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #ffffff;
    line-height: 1;
    padding: 0;
    border-radius: 0;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  .header-profile:hover {
    background: transparent;
    opacity: 0.8;
  }
  .header-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 9999px;
    background: rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
  }
  .header-username {
    font-size: 14px;
    font-weight: 500;
  }
`;

const MenuHeader = styled(Menu)`
  min-width: 208px;
  padding: 4px !important;
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(0, 0, 0, 0.05);

  /* antd เว้น title ของ group 5px 12px และ list 0 8px ชื่อและปุ่ม logout จึงห่างขอบเกิน SIS (HD:91-101: p-3 / p-1) */
  .ant-dropdown-menu-item-group-title {
    padding: 0;
  }
  .ant-dropdown-menu-item-group-list {
    margin: 0;
  }
  .profile-info {
    padding: 8px 8px 12px;
    margin-bottom: 4px;
    border-bottom: 1px solid #f1f5f9;
    line-height: 1.4;
  }
  .profile-name {
    color: #1e293b;
    font-weight: 600;
    font-size: 14px;
  }
  .profile-username {
    color: var(--text-muted);
    font-size: 12px;
  }
  .ant-dropdown-menu-item.logout-item {
    color: var(--danger-text);
    font-weight: 600;
    border-radius: 8px;
    padding: 10px 12px;
    line-height: 20px;
  }
  /* antd ใส่สี rgba(0,0,0,.85) ให้ลิงก์ใน menu item เอง สีแดงของ item จึงไม่ถึงตัวอักษร ให้ลิงก์ใช้สีของ item */
  .ant-dropdown-menu-item.logout-item > a {
    color: inherit;
  }
  /* บนพื้น #fef2f2 สี --danger-text ได้แค่ 4.36:1 ตอน hover จึงเข้มขึ้นเป็น --primary-hover (5.13:1) */
  .ant-dropdown-menu-item.logout-item:hover {
    color: var(--primary-hover);
    background: #fef2f2;
  }
  /* ปุ่มสลับภาษา (Header.js) ขนาดและระยะเท่าปุ่ม logout แต่เป็นสีปกติ hover พื้น slate-50 แบบเมนูของ SIS */
  .ant-dropdown-menu-item.lang-item {
    color: var(--text-body);
    font-weight: 600;
    border-radius: 8px;
    padding: 10px 12px;
    line-height: 20px;
  }
  .ant-dropdown-menu-item.lang-item:hover {
    color: var(--text-heading);
    background: #f8fafc;
  }
  /* เปิดเมนูด้วยคีย์บอร์ด focus อยู่ที่เมนู ให้เห็นทั้งเมนูและ item ที่เลือกด้วยลูกศร (วงแดง 2px แบบ :focus-visible ใน sis-theme.css)
     เปิดด้วยเมาส์ :focus-visible ไม่ขึ้น หน้าตาจึงเหมือนเดิม */
  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
  &:focus-visible .ant-dropdown-menu-item-active {
    box-shadow: inset 0 0 0 2px var(--primary);
  }
`

const LoginBackground = styled.div`
  min-height: 100vh;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 0;

  @media (min-width: 640px) {
    padding: 48px 24px;
  }
  @media (min-width: 1024px) {
    padding: 48px 32px;
  }

  .login-brand,
  .login-card-wrapper {
    width: 100%;
    margin: 0 auto;
  }
  @media (min-width: 640px) {
    .login-brand,
    .login-card-wrapper {
      max-width: 448px;
    }
  }

  .login-logo {
    display: flex;
    justify-content: center;
    padding: 0 16px;
  }
  .login-logo img {
    height: 64px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
  }
  .login-title {
    margin: 24px 0 0;
    text-align: center;
    font-size: 30px;
    line-height: 36px;
    font-weight: 800;
    color: #1e293b;
  }

  .login-card-wrapper {
    margin-top: 32px;
  }
  .login-card {
    background: #ffffff;
    padding: 32px 16px;
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  }
  @media (min-width: 640px) {
    .login-card {
      padding: 32px 40px;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
    }
  }

  .login-alert {
    display: flex;
    gap: 12px;
    background: #fef2f2;
    border-left: 4px solid #dc2626;
    padding: 16px;
    margin-bottom: 24px;
    font-size: 14px;
    color: #b91c1c;
  }
  .login-alert .anticon {
    color: #dc2626;
    font-size: 18px;
    margin-top: 1px;
  }

  /* form (username / password) */
  .ant-form-vertical .ant-form-item {
    margin-bottom: 24px;
  }
  .ant-form-vertical .ant-form-item-label {
    padding: 0 0 4px;
  }
  .ant-form-vertical .ant-form-item-label > label {
    font-size: 14px;
    font-weight: 500;
    color: #4b5563;
  }
  .ant-form-vertical .ant-form-item-label > label::before {
    display: none !important;
  }
  .ant-input,
  .ant-input-affix-wrapper {
    border-radius: 6px;
    font-size: 14px;
    color: #000;
    box-shadow: var(--shadow-sm);
  }
  .ant-input-affix-wrapper {
    padding: 7px 12px;
  }
  .ant-input {
    height: 38px;
    padding: 7px 12px;
  }
  .ant-input-affix-wrapper {
    height: 38px;
  }
  .ant-input-affix-wrapper > input.ant-input {
    height: auto;
    padding: 0;
    box-shadow: none;
  }
  .ant-input-affix-wrapper:hover,
  .ant-input:hover {
    border-color: #cbd5e1;
  }
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus,
  .ant-input:focus {
    border-color: #dc2626 !important;
    box-shadow: var(--shadow-sm) !important;
  }
  .ant-input-password-icon.anticon {
    font-size: 20px;
    color: #4b5563;
  }
  .ant-input-password-icon.anticon:hover {
    color: var(--text-heading);
  }

  .login-btn {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    height: 38px;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    box-shadow: var(--shadow-sm);
  }
  .login-btn-primary,
  .login-btn-primary:focus {
    color: #ffffff;
    background: #dc2626;
    border-color: #dc2626;
  }
  .login-btn-primary:hover {
    color: #ffffff;
    background: #b91c1c;
    border-color: #b91c1c;
  }
  .login-btn-primary.ant-btn-loading {
    background: #f87171;
    border-color: #f87171;
    cursor: not-allowed;
  }
  .login-btn-contractor,
  .login-btn-contractor:focus {
    color: #ffffff;
    background: #1e3a5f;
    border-color: #1e3a5f;
  }
  .login-btn-contractor:hover {
    color: #ffffff;
    background: #152b47;
    border-color: #152b47;
  }
`

export {
  StyledHearder,
  StyledLogo,
  StyledSearchForm,
  StyledHeader1,
  GeneralStyledContent,
  StyledSider,
  StyledImageHeader,
  MenuHeader,
  LoginBackground
};
